import {ConfirmSkipModalProps} from '../model/types';

export const ConfirmSkipModal = ({isOpen, onClose, onConfirm}: ConfirmSkipModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <button className="modal-close" onClick={onClose}>
            <i className="pi pi-times"></i>
          </button>
        </div>
        <div className="modal-body">
          <div className="modal-icon">
            <div className="warning-icon"></div>
          </div>
          <h3 className="modal-title">Are you sure you want to skip this step?</h3>
          <p className="modal-description">
            The platform experience will be limited unless you create or join an organisation. You will not be able to
            start your free trial, either.
          </p>
        </div>
        <div className="modal-footer">
          <button className="modal-button secondary" onClick={onClose}>
            Go back
          </button>
          <button className="modal-button primary" onClick={onConfirm}>
            Yes, skip this step
          </button>
        </div>
      </div>
    </div>
  );
};
